<!--
 * @Descripttion: 折叠按钮组
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-12-10 17:15:09
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-07-05 11:22:52
-->
<template>
	<el-dropdown placement="bottom" @command="handleCommand" v-if="list.length">
		<el-button>
			{{ btnText }}
			<i class="el-icon-arrow-down el-icon--right"></i>
		</el-button>
		<el-dropdown-menu class="foldButton" slot="dropdown">
			<div v-for="btn in list" :key="btn.key">
				<!-- 需要展示tooltip，传递tip值生成tooltip，传递showTip解锁tooltip，即使按钮禁用也可以展示tooltip -->
				<el-tooltip :content="btn.tip" placement="right" :disabled="!btn.showTip" v-if="btn.tip" :open-delay="300">
					<div>
						<el-dropdown-item :disabled="btn.disabled" :command="btn.key">
							<span class="font-h4-regular pt-6 pb-6">{{ btn.btnTxt }}</span>
						</el-dropdown-item>
					</div>
				</el-tooltip>
				<!-- 不需要展示tooltip，就展示正常的dropdown-item -->
				<el-dropdown-item :disabled="btn.disabled" :command="btn.key" v-else>
					<span class="font-h4-regular pt-6 pb-6">{{ btn.btnTxt }}</span>
				</el-dropdown-item>
			</div>
		</el-dropdown-menu>
	</el-dropdown>
</template>
<script>
export default {
	name: 'FoldButton',
	props: {
		// 单个按钮配置信息
		// key:必填，唯一识别按钮
		// btnTxt:必填，按钮展示文本
		// tip:选填，用于tooltip中展示的文案，如果没有传即使showTip为true也不会展示tooltip
		// showTip:选填，判断是否展示tooltip，true为展示，false为不展示，前提需要tip有值
		// disabled:选填，按钮禁用状态，true为禁用，false为不禁用，
		// hidden: 选填，按钮是否隐藏，true为隐藏，false为不隐藏，
		// click:选填，按钮点击事件
		buttons: {
			type: Array,
			default: () => [],
		},
		btnText: {
			type: String,
			default: '其他操作',
		},
	},
	computed: {
		list() {
			return this.buttons.filter(item => !item.hidden);
		},
	},
	methods: {
		handleCommand(command) {
			const targetEvent = this.list.find(item => item.key === command);
			targetEvent?.click?.();
		},
	},
};
</script>
<style lang="less">
.foldButton.el-dropdown-menu--small {
	padding: 14px 0;
	.el-dropdown-menu__item {
		line-height: 24px;
		padding: 6px 16px;
	}
}
</style>
